import PageTitle from "../components/common/PageTitle";
import { TEXT_NORMAL, TEXT_SMALL } from "../style";

export default function AiPlanner() {
    return (
        <div className="flex flex-column h-full overflow-hidden">
            <PageTitle title="Ai Planner" />
            <div className="flex flex-column flex-1 align-items-center justify-content-center p-4 text-center">
                <i className="pi pi-sparkles text-primary mb-3" style={{ fontSize: "2.5rem" }} />
                <p className={`${TEXT_NORMAL} font-semibold m-0`}>Coming Soon</p>
                <p className={`${TEXT_SMALL} text-color-secondary mt-2 mb-0`}>AI Planner is not available yet. Check back later.</p>
            </div>
        </div>
    );
}
